/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { assetListErrorAction, assetListLoadingAction, assetListUpdateAction } from './assetListSlice'
import * as AssetListService from '../services/assetListService'
import { assetDeleteErrorAction, assetDeleteLoadingAction, assetDeleteUpdateAction } from './assetDeleteSlice'
import * as AssetDeleteService from '../services/assetDeleteService'
import { siteInfoLoadingAction, siteInfoUpdateAction, siteInfoErrorAction } from './siteInfoSlice'
import * as siteInfoService from '../services/siteInfoService'
import { type AppDispatch } from '../../../store'
import { createAssetLoadingAction, createAssetUpdateAction, createAssetErrorAction } from './createAssetSlice'
import * as CreateAssetService from '../services/createAssetService'
import * as ImageUploadService from '../services/imageUploadService'
import * as UpdateAssetService from '../services/updateAssetService'
import { type ImageUploadApiResponse, type ImageUploadPostRequest } from '../services/imageUploadService'
import { ImageUploadLoadingAction, ImageUploadUpdateAction, ImageUploadErrorAction } from './imageUploadSliceAsset'
import { type CreateAssetApiResponse, type CreateAssetPostRequest } from '../services/createAssetService'
import { type UpdateAssetPutRequest, type UpdateAssetApiResponse } from '../services/updateAssetService'
import { updateAssetLoadingAction, updateAssetErrorAction, updateAssetUpdateAction } from './updateAssetSlice'
import { getBookmarkListDataservice } from '../../bookmarks-home/redux/actionCreator'

export const fetchAssetList =
  (siteId: string, assetTypeId: string, PageNumber: number, PageItems: number, searchKey: string, SortParams: string, parentAssetId: string, sortField: string) =>
    async (dispatch: any): Promise<void> => {
      dispatch(assetListLoadingAction())
      void AssetListService.getAssetList(
        siteId,
        assetTypeId,
        PageNumber,
        PageItems,
        searchKey,
        SortParams,
        parentAssetId,
        sortField,
        (assetList, httpStatus) => {
          dispatch(
            assetListUpdateAction({
              data: assetList.assets,
              count: assetList.total_count,
              httpStatus
            })
          )
        },
        (errorMessage, httpStatus) => {
          // istanbul ignore next
          dispatch(assetListErrorAction({ errorMessage, httpStatus }))
        }
      )
    }

export const assetDeleteCampaign = (selectedAssetId: string, subId: string) => async (dispatch: any): Promise<void> => {
  dispatch(assetDeleteLoadingAction())
  void AssetDeleteService.assetDeleteCampaign(selectedAssetId,
    (deleteStatusData: any, httpStatus: any) => {
      dispatch(
        assetDeleteUpdateAction({
          data: deleteStatusData,
          httpStatus
        })
      )
      dispatch(getBookmarkListDataservice(subId))
    },
    (errorMessage: any, httpStatus: any) => {
      // istanbul ignore next
      dispatch(assetDeleteErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const fetchSiteInfo = (selectedAssetId: string) => async (dispatch: any): Promise<void> => {
  dispatch(siteInfoLoadingAction())
  void siteInfoService.siteInfoService(selectedAssetId,
    (deleteStatusData, httpStatus) => {
      dispatch(
        siteInfoUpdateAction({
          data: deleteStatusData,
          httpStatus
        })
      )
    },
    (errorMessage, httpStatus) => {
      dispatch(siteInfoErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const createAsset = (createAssetPostRequest: CreateAssetPostRequest) => async (dispatch: AppDispatch): Promise<void> => {
  dispatch(createAssetLoadingAction())
  void CreateAssetService.createAsset(
    createAssetPostRequest,
    (CreateAssetApiResponse: CreateAssetApiResponse, httpStatus: number) => {
      dispatch(
        createAssetUpdateAction({
          data: CreateAssetApiResponse, httpStatus
        })
      )
    },
    (errorMessage, httpStatus) => {
      // istanbul ignore next
      dispatch(createAssetErrorAction({ errorMessage, httpStatus }))
    }
  )
}

// istanbul ignore next
export const imageUpload = (imageUploadPostRequest: ImageUploadPostRequest) => async (dispatch: AppDispatch): Promise<void> => {
  dispatch(ImageUploadLoadingAction())
  void ImageUploadService.imageUpload(
    imageUploadPostRequest,
    (imageUploadApiResponse: ImageUploadApiResponse, httpStatus: number) => {
      dispatch(
        ImageUploadUpdateAction({
          data: imageUploadApiResponse, httpStatus
        })
      )
    },
    (errorMessage, httpStatus) => {
      dispatch(ImageUploadErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const updateAsset = (updateAssetPutRequest: UpdateAssetPutRequest) => async (dispatch: AppDispatch): Promise<void> => {
  // istanbul ignore next
  dispatch(updateAssetLoadingAction())
  // istanbul ignore next
  void UpdateAssetService.updateAsset(
    updateAssetPutRequest,
    (UpdateAssetApiResponse: UpdateAssetApiResponse, httpStatus: number) => {
      // istanbul ignore next
      dispatch(
        updateAssetUpdateAction({
          data: UpdateAssetApiResponse, httpStatus
        })
      )
    },
    (errorMessage, httpStatus) => {
      // istanbul ignore next
      dispatch(updateAssetErrorAction({ errorMessage, httpStatus }))
    }
  )
}
